module.exports = __webpack_public_path__ + "static/media/cw_chatpage_h.2d1206ba.png";